import clone from "just-clone";
import {
  MODOS_CONTAGEM_TAXA_FIXA,
  MODO_CONTAGEM_PADRAO,
  MOMENTOS_CONTAGEM_TAXA_FIXA,
  MOMENTO_CONTAGEM_PADRAO,
  PERIODOS_TAXA_FIXA,
  TAXA_FIXA_PADRAO,
  dataApi,
} from "../constantes";

export const LIMITE_MAXIMO_OCORRENCIAS = 32767;

const CAMPOS_LISTA = ["produtos", "dimensoes", "promocoesExcessao", "restricoes"];

const CAMPOS_DIMENSAO = ["coluna", "dimensao_id", "coluna_vinculada", "dimensao_vinculada_id"];

const vazio = (valor) => valor === null || valor === undefined || String(valor).trim() === "";

const possui = (objeto, chave) => Object.prototype.hasOwnProperty.call(objeto, chave);

function cobrancaDe(cobranca) {
  if (cobranca === null || typeof cobranca !== "object") return vazio(cobranca) ? null : { id: cobranca, descricao: "" };

  return vazio(cobranca.id) ? null : { id: cobranca.id, descricao: cobranca.descricao || "" };
}

function cobrancasDe(taxaFixa) {
  const lista = Array.isArray(taxaFixa.cobrancas)
    ? taxaFixa.cobrancas
    : vazio(taxaFixa.cobranca_id)
    ? []
    : [{ id: taxaFixa.cobranca_id, descricao: taxaFixa.cobranca_descricao }];

  return lista
    .map(cobrancaDe)
    .filter((cobranca, indice, todas) => cobranca && todas.findIndex((outra) => outra && String(outra.id) === String(cobranca.id)) === indice);
}

export function normalizarTaxaFixa(taxaFixa) {
  if (!taxaFixa) return TAXA_FIXA_PADRAO();

  const resto = clone(taxaFixa);

  delete resto.cobranca_id;
  delete resto.cobranca_descricao;

  return {
    ...resto,
    cobrancas: cobrancasDe(taxaFixa),
    modo_contagem: vazio(resto.modo_contagem) ? MODO_CONTAGEM_PADRAO : resto.modo_contagem,
    momento_contagem: vazio(resto.momento_contagem) ? MOMENTO_CONTAGEM_PADRAO : resto.momento_contagem,
  };
}

export function taxaFixaParaPayload(taxaFixa) {
  const normalizada = normalizarTaxaFixa(taxaFixa);

  return {
    cobrancas: normalizada.cobrancas.map((cobranca) => cobranca.id),
    limite_ocorrencias: normalizada.limite_ocorrencias,
    periodo_ocorrencias: normalizada.periodo_ocorrencias,
    modo_contagem: normalizada.modo_contagem,
    momento_contagem: normalizada.momento_contagem,
  };
}

const SUFIXO_TAXA_FIXA = /\s*\(\s*taxa\s+fixa\s+R\$[^)]*\)\s*$/i;

const FORMATO_MOEDA = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export function nomeCurtoCobranca(descricao) {
  const texto = String(descricao === null || descricao === undefined ? "" : descricao).trim();

  return texto.replace(SUFIXO_TAXA_FIXA, "").trim() || texto;
}

export function formatarTaxaFixa(valor) {
  if (vazio(valor) || !Number.isFinite(Number(valor))) return "";

  return FORMATO_MOEDA.format(Number(valor));
}

export const nomeCobranca = (cobranca) => nomeCurtoCobranca(cobranca.descricao) || String(cobranca.id);

const emLista = (itens) => (itens.length < 2 ? itens.join("") : `${itens.slice(0, -1).join(", ")} e ${itens[itens.length - 1]}`);

export function momentoContagemTaxaFixa(taxaFixa) {
  const momento = taxaFixa && !vazio(taxaFixa.momento_contagem) ? taxaFixa.momento_contagem : MOMENTO_CONTAGEM_PADRAO;

  return MOMENTOS_CONTAGEM_TAXA_FIXA[momento] || momento;
}

export function resumoLimiteTaxaFixa(taxaFixa) {
  const atual = taxaFixa || {};
  const limite = Number(atual.limite_ocorrencias) || 0;
  const periodo = (PERIODOS_TAXA_FIXA[atual.periodo_ocorrencias] || "").toLowerCase();

  if (!limite || !periodo) return null;

  const nomes = cobrancasDe(atual).map(nomeCobranca);
  const frase = `Cada cliente paga a taxa em até ${limite} ${limite === 1 ? "pedido" : "pedidos"} ${periodo}`;

  if (!nomes.length) {
    return atual.modo_contagem === "PEDIDO" ? `${frase}, somando todas as cobranças com taxa fixa.` : `${frase} em cada cobrança com taxa fixa.`;
  }
  if (nomes.length === 1) return `${frase} com a cobrança ${nomes[0]}.`;
  if (atual.modo_contagem === "PEDIDO") return `${frase}, somando as cobranças ${emLista(nomes)}.`;

  return `${frase} em cada cobrança: ${emLista(nomes)}.`;
}

export function resumoTaxaFixa(taxaFixa) {
  const limite = resumoLimiteTaxaFixa(taxaFixa);

  return limite ? `${limite} Contar o pedido: ${momentoContagemTaxaFixa(taxaFixa)}.` : null;
}

export function prepararRegra(item) {
  const regra = clone(item || {});

  regra.data_inicial = dataApi(regra.data_inicial);
  regra.data_final = dataApi(regra.data_final);

  CAMPOS_LISTA.forEach((campo) => {
    if (!Array.isArray(regra[campo])) regra[campo] = [];
  });

  regra.taxaFixa = normalizarTaxaFixa(regra.taxaFixa);

  return regra;
}

export function montarPayload(regra) {
  const payload = clone(regra);

  payload.data_inicial = dataApi(payload.data_inicial);
  payload.data_final = dataApi(payload.data_final);

  if (payload.tipo === "TF") payload.taxaFixa = taxaFixaParaPayload(payload.taxaFixa);
  else delete payload.taxaFixa;

  return payload;
}

export function camposAoTrocarTipo(regra, novoTipo) {
  const campos = {
    tipo: novoTipo,
    produtos: [],
    dimensoes: [],
    promocoesExcessao: [],
    perc_max_promocao: 0,
    perc_max_mix: 0,
    validar_todas_regras: 1,
    taxaFixa: regra && regra.taxaFixa ? regra.taxaFixa : TAXA_FIXA_PADRAO(),
  };

  // DESABILITADO POR MOTIVOS DE SEGURANÇA
  // if (novoTipo !== 'SP') {
  //   this.item.scriptPHP.script = null;
  //   this.tempScripts.php = null;
  // }
  if (novoTipo !== "QS") campos.querySQL = { query: null, banco: null };

  // DESABILITADO POR MOTIVOS DE SEGURANÇA
  // if (tipoAnterior === 'SP') {
  //   codigoAnterior = this.tempScripts.php || this.item.scriptPHP.script || '';
  // } 
  // DESABILITADO POR MOTIVOS DE SEGURANÇA
  // if (novoTipo === 'SP') {
  //   this.tempScripts.php = codigoAnterior;
  //   this.item.scriptPHP = { script: codigoAnterior };
  //   this.item.querySQL = {
  //     query: null,
  //     banco: null
  //   };
  // }
  // DESABILITADO POR MOTIVOS DE SEGURANÇA
  // this.item.scriptPHP = {
  //   script: null
  // };
  // DESABILITADO POR MOTIVOS DE SEGURANÇA
  // if (novoTipo === 'SP') {
  //   this.tempScripts.php = null;
  //   this.item.scriptPHP.script = null;
  // }

  return campos;
}

export function validarRegra(regra) {
  const erros = [];
  const adicionar = (etapa, campo, mensagem) => erros.push({ etapa, campo, mensagem });

  if (vazio(regra.descricao)) adicionar(0, "descricao", "Informe a descrição da regra.");

  if (regra.data_inicial && regra.data_final && dataApi(regra.data_final) < dataApi(regra.data_inicial)) {
    adicionar(0, "data_final", "A data de término não pode ser anterior à data de início.");
  }

  if (!regra.tipo) adicionar(1, "tipo", "Escolha o tipo da regra.");

  if (regra.tipo === "M" && !(regra.produtos || []).length) {
    adicionar(1, "produtos", "Inclua ao menos um produto no mix.");
  }

  if (regra.tipo === "D") {
    const dimensoes = regra.dimensoes || [];

    if (!dimensoes.length) adicionar(1, "dimensoes", "Inclua ao menos uma regra de validação.");
    else if (dimensoes.some((dimensao) => CAMPOS_DIMENSAO.some((campo) => vazio(dimensao[campo])))) {
      adicionar(1, "dimensoes", "Escolha os segmentos de todas as regras de validação.");
    }
  }

  if (regra.tipo === "QS") {
    const querySQL = regra.querySQL || {};

    if (!querySQL.banco) adicionar(1, "querySQL.banco", "Escolha onde a consulta será executada.");
    if (vazio(querySQL.query)) adicionar(1, "querySQL.query", "Escreva a consulta SQL da regra.");
  }

  if (regra.tipo === "TF") {
    const taxaFixa = regra.taxaFixa || {};
    const limite = vazio(taxaFixa.limite_ocorrencias) ? NaN : Number(taxaFixa.limite_ocorrencias);

    const modo = vazio(taxaFixa.modo_contagem) ? MODO_CONTAGEM_PADRAO : taxaFixa.modo_contagem;
    const momento = vazio(taxaFixa.momento_contagem) ? MOMENTO_CONTAGEM_PADRAO : taxaFixa.momento_contagem;

    if (!possui(MODOS_CONTAGEM_TAXA_FIXA, modo)) adicionar(1, "taxaFixa.modo_contagem", "Escolha a validação da taxa.");

    if (!possui(MOMENTOS_CONTAGEM_TAXA_FIXA, momento)) adicionar(1, "taxaFixa.momento_contagem", "Escolha quando contar o pedido.");

    if (!Number.isInteger(limite) || limite < 1 || limite > LIMITE_MAXIMO_OCORRENCIAS) {
      adicionar(1, "taxaFixa.limite_ocorrencias", `O limite por cliente deve ser um número inteiro entre 1 e ${LIMITE_MAXIMO_OCORRENCIAS}.`);
    }

    if (!possui(PERIODOS_TAXA_FIXA, taxaFixa.periodo_ocorrencias)) {
      adicionar(1, "taxaFixa.periodo_ocorrencias", "Escolha o período do limite.");
    }
  }

  return erros;
}

export function mapaDeErros(erros) {
  return erros.reduce((mapa, erro) => {
    if (!mapa[erro.campo]) mapa[erro.campo] = erro.mensagem;

    return mapa;
  }, {});
}
